// extracted by mini-css-extract-plugin
export default {"SocialProfileWrapper":"PostCardStatusTable_SocialProfileWrapper__oCCzs","DateText":"PostCardStatusTable_DateText__toeJX","Width100":"PostCardStatusTable_Width100__SzreP"};